import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "./AuthContextComponent";
import { ROUTES, STATUS, TYPE } from "../lib/enums/index";
import { IoNotifications } from "react-icons/io5";
import { GrAnnounce } from "react-icons/gr";
import { MdAnnouncement } from "react-icons/md";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import useHeadComponent from "../hooks/HeaderHook";
import ProfileDropdown from "./dropdown/ProfileDropdown";
import Logo from "../lib/images/mlhuillier.png";
import TransactionDropdown from "./dropdown/TransactionDropdown";
import {
  transactionPages,
  uploaderTransactionPages,
} from "../lib/constants/values/Values";
import useUserLogin from "../hooks/UserLoginhook";
import MLBannerWhite from "../lib/images/MLBannerWhite.png";
import { accountNumber } from "../lib/config/Config";
import { useCustomAccount } from "./CustomAccountContext";
import NotificationBell from "./NotificationComponent";

interface Props {
  Balance?: string;
  theme?: string;
  selectedPartner?: any;
}

const Header: React.FC<Props> = ({
  Balance,
  theme,
  selectedPartner,
  // customBannerImg,
}) => {
  const {
    img,
    // bannerImg,
    customBannerImg,
    prefundInfo,

    handleReportsRedirection,
    // handleBannerImg,
    handleTransactionPagesRedirection,
  } = useHeadComponent(selectedPartner);
  const { userInfo, approverStatus } = useContext(AuthContext);

  const { customAccount, bannerImg } = useCustomAccount();

  const { customColor } = useUserLogin();

  const [nav, setNav] = useState(false);

  const backgroundColor = theme === "DARK" ? "#24292e" : "";

  const isUploader = userInfo?.isUploader;
  const isApprover = userInfo?.isApprover;

  const handleSideNavClick = () => {
    setNav(!nav);
  };
  const balanceLocation = useLocation();
  const NavLink: React.FC<{
    to: string;
    children: React.ReactNode;
    nav?: boolean;
  }> = ({ to, children, nav }) => {
    const location = useLocation();

    const [isHovered, setIsHovered] = useState(false);

    return (
      <Link
        to={to}
        className={`px-4 sm:text-md ${
          location.pathname === to
            ? "font-bold md:text-white sm:text-gray-400"
            : ""
        } active:text-white ${
          theme === "DARK"
            ? "hover:text-custom-default-hover"
            : `hover:text-white ${nav ? "hover:text-black" : ""}`
        } text-md ${isHovered ? "text-black" : "hover:text-17px"}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {children}
      </Link>
    );
  };

  return (
    <div
      className="sticky top-0 z-50 w-full"
      style={{
        fontFamily: "Poppins",
      }}
    >
      <div
        className={`flex justify-between items-center h-16 text-white transition-colors duration-1000 ease-in-out px-4 mx-auto ${
          theme === `DARK` ? `` : `bg-custom-default`
        } shadow-lg`}
        style={{
          backgroundColor: customColor,
        }}
      >
        <div className="items-center hidden gap-2 font-semibold text-left text-custom-default-header-text text-custom-petite md:flex">
          <img
            src={
              accountNumber === "0" ? MLBannerWhite : customAccount?.bannerImg
            }
            alt="Logo.png"
            className="h-full px-4 w-52 "
          />

          {isUploader || (isApprover && isUploader) ? (
            <NavLink to={ROUTES.MANUALUPLOAD}>Upload</NavLink>
          ) : null}

          <TransactionDropdown
            options={
              userInfo?.isUploader ? uploaderTransactionPages : transactionPages
            }
            onSelect={handleTransactionPagesRedirection}
          />

          {approverStatus ? (
            <NavLink to={ROUTES.TRACK}>Approval Status</NavLink>
          ) : null}

          {isApprover ? (
            <NavLink to={ROUTES.APPROVE}>Pending Request</NavLink>
          ) : null}

          {userInfo?.category === STATUS.EXTERNAL ? (
            <>
              {" "}
              <div
                className="ml-5 cursor-pointer hover:text-white"
                onClick={handleReportsRedirection}
              >
                Reports
              </div>
            </>
          ) : (
            <></>
          )}
          {/* <DownloadButton /> */}
        </div>

        <div onClick={handleSideNavClick} className="block px-4 md:hidden">
          {!nav ? <AiOutlineMenu size={20} /> : null}
        </div>

        <div
          className={
            nav
              ? "fixed left-0 top-0 w-[45%] h-full border-r bg-slate-100 transition-all duration-1000 ease-in-out z-50"
              : "fixed left-[-100%]"
          }
        >
          <div
            className={`flex justify-between items-center mx-auto px-4 shadow-lg h-16 ${
              theme === `DARK`
                ? `bg-custom-dark-theme-primary-bg `
                : `bg-custom-default `
            }`}
            style={{
              backgroundColor: customColor,
            }}
          >
            <div>
              <h1 className="py-4 mx-auto md:text-2xl sm:text-xl">
                <img
                  src={accountNumber === "0" ? Logo : customAccount?.bannerImg}
                  alt="mlhuillier.png"
                  className="h-10 w-22"
                />
              </h1>
            </div>

            <div onClick={handleSideNavClick} className="cursor-pointer">
              <AiOutlineClose size={15} />
            </div>
          </div>

          <div
            className={`flex flex-col items-start text-custom-petite sm:text-custom-micro h-full gap-4 py-4 px-4 ${
              theme === `DARK`
                ? `bg-custom-dark-theme-secondary-bg text-custom-dark-theme-text`
                : `bg-slate-100 text-black`
            }`}
          >
            {isUploader || (isApprover && isUploader) ? (
              <NavLink to={ROUTES.MANUALUPLOAD} nav={nav}>
                Upload
              </NavLink>
            ) : null}

            <TransactionDropdown
              options={
                userInfo?.isUploader
                  ? uploaderTransactionPages
                  : transactionPages
              }
              onSelect={handleTransactionPagesRedirection}
            />
            <NavLink to={ROUTES.TRACK} nav={nav}>
              Approval Status
            </NavLink>
            {isApprover ? (
              <NavLink to={ROUTES.APPROVE} nav={nav}>
                Pending Request
              </NavLink>
            ) : null}
            {userInfo?.category === STATUS.EXTERNAL ? (
              <>
                {" "}
                <div
                  className={` px-4 cursor-pointer hover:text-white`}
                  onClick={handleReportsRedirection}
                >
                  Reports
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>

        <div className="flex items-center gap-4 text-custom-petite text-custom-default-header-text ">
          {/* {userInfo?.category === STATUS.INTERNAL &&
          selectedPartner &&
          balanceLocation.pathname === "/paymentsolution/manual-upload" ? (
            <div className="px-4 text-left w-52">
              Balance : {prefundInfo?.currency} {Balance}
            </div>
          ) : userInfo?.category !== STATUS.INTERNAL ? (
            <div className="text-left w-52">
              Balance : {prefundInfo?.currency} {Balance}
            </div>
          ) : null} */}

          <div title="Notifications">
            <NotificationBell />
          </div>

          <NavLink to={ROUTES.PATCHNOTE}>
            <MdAnnouncement
              title="Patch Notes"
              className={`text-xl transition-all h-full duration-300 text-gray-300 ${
                theme === `DARK`
                  ? `hover:text-custom-default-hover`
                  : `hover:text-white`
              } hover:scale-110`}
            />
          </NavLink>

          <div className="mr-10" title="Profile">
            <ProfileDropdown />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
